import * as angular from 'angular';
import { IAugmentedJQuery, IComponentController, IRootScopeService, IScope, ITimeoutService } from 'angular';
import { IProfil, IProfilAcces } from '../../../../core/resources/profil.resource';
import { IParametresSecuriteService } from '../../../../core/services/parametres-securite.service';
import { IComposantMonoOccurrenceEcran } from '../../../../core/components/ex-mono-occurrence-ecran/ex-mono-occurrence-ecran.controller';
import { IComposantMultiOccurrenceAnalyse } from '../ex-multi-occurrence-analyse/ex-multi-occurrence-analyse.controller';
import { IComposantMultiOccurrenceMaitreDetailsEcran } from '../ex-multi-occurrence-maitre-details-ecran/ex-multi-occurrence-maitre-details-ecran.controller';
import { IMultiOccurrence } from '../../../../core/services/multi-occurrence.service';
import { IEcranContextController } from '../../../../core/behaviors/ex-ecran-context/ex-ecran-context.behavior';
import IResourceService = angular.resource.IResourceService;
import { IApiConfig } from "../../../../core/interfaces/api-config.interface";
import { IEcranDetailsResourcesEntite } from "../../../../core/resources/ecran-details.resource";
import { IMenuNavigationItem } from "../../../../core/interfaces/menu-navigation-item.interface";
import { IFavorisMenu } from "../../../../core/interfaces/favoris-menu.interface";
import { IStateService } from "angular-ui-router";

interface IComposantMenuEmploye extends IComponentController {
    ecranContextCtrl: IEcranContextController;
    profilsAcces: Array<IProfilAcces>;
    profilsAffiches: Array<IProfilAcces>
    rendering: boolean;
    activeRow: any;
    monoOccurrenceEcranCtrl: IComposantMonoOccurrenceEcran;
    multiOccurrenceAnalyseCtrl: IComposantMultiOccurrenceAnalyse;
    multiOccurrenceMaitreDetailsEcranCtrl: IComposantMultiOccurrenceMaitreDetailsEcran;
    queryParams: any;
    infosEmploye: string | undefined;
    cleFavoris: string;
    favorisBagName: string;
    favoris: any[];
    syncFavorisOrder(event: MouseEvent): void;
}

/* @ngInject */
export default function MenuEmployeController(profil: IProfil,
    $scope: IScope, $rootScope: IRootScopeService, $state: IStateService,
    $timeout: ITimeoutService,
    parametresSecurite: IParametresSecuriteService,
    $resource: IResourceService,
    ApiConfig: IApiConfig,
    $stateParams: any,
    ecranDetails: IEcranDetailsResourcesEntite) {
    const vm: IComposantMenuEmploye = this;
    const resource = $resource(`${ApiConfig.ROOT}/liste-valeurs/epl-dem`);
    const employeParam = $stateParams.employe;
    let unregisterActiveRowChange: Function | null = null;
    let unregisterDemcleintChange: Function | null = null;
    let unregisterFavoris: Function | null = null;

    vm.vaesysapp = "SOF2"
    vm.cleFavoris = "ex-menu-employe-favoris"
    vm.favorisBagName = `${vm.cleFavoris}-ordre`;
    vm.syncFavorisOrder = syncFavorisOrder;
    vm.$onInit = function $onInit() {
        const { pracleint } = parametresSecurite(vm.ecranContextCtrl.stateParams);
        const currentProfilAcces = profil.profilsAcces
            .find((profilAcces: IProfilAcces) => {
                return (profilAcces.pracleint === pracleint);
            });
        vm.profilsAcces = [{ ...currentProfilAcces, dscmnu: '', menus: currentProfilAcces.menusEmploye }];

        vm.queryParams = {
            employe: employeParam || null
        };

        if (vm?.monoOccurrenceEcranCtrl?.monoOccurrence?.noId && vm.monoOccurrenceEcranCtrl?.getMultiOccurrenceAdvanced()) {
            configureMultiOccurrenceComposant()
        }
        else if (vm.monoOccurrenceEcranCtrl) {
            const data = vm.monoOccurrenceEcranCtrl.monoOccurrence.data;

            vm.queryParams.employe = data.demcleint || data.employe_demcleint || $stateParams.employe;

            unregisterDemcleintChange = $scope.$watch("vm.monoOccurrenceEcranCtrl.monoOccurrence.data.demcleint", (newValue, oldValue) => {
                if (newValue !== oldValue) {
                    vm.queryParams.employe = newValue
                    vm.activeRow = vm.monoOccurrenceEcranCtrl.monoOccurrence.data;
                    fetchEmploye()
                }
            })

            vm.activeRow = vm.monoOccurrenceEcranCtrl.monoOccurrence.data;
            fetchEmploye()
        } else {
            configureMultiOccurrenceComposant()
        }       

        const favoris = localStorage.getItem(vm.cleFavoris);
        vm.favoris = favoris ? prepareFavoris(JSON.parse(favoris)) : [];

        unregisterFavoris = $rootScope.$on(vm.cleFavoris, (event, favoris) => {
            vm.favoris = prepareFavoris(favoris);
        });
       
    }

    $scope.$on('$destroy', () => {        
        if (unregisterDemcleintChange) { unregisterDemcleintChange(); };
        if (unregisterActiveRowChange) { unregisterActiveRowChange(); };
        if (unregisterFavoris) { unregisterFavoris(); };
    });

    function configureMultiOccurrenceComposant() {
        vm.rendering = false;
        const multiOccurrenceComposant = vm.multiOccurrenceAnalyseCtrl || vm.multiOccurrenceMaitreDetailsEcranCtrl || vm.monoOccurrenceEcranCtrl?.getMultiOccurrenceAdvanced();

        if (multiOccurrenceComposant &&
            (
                multiOccurrenceComposant.multiOccurrence.schema &&
                (multiOccurrenceComposant.multiOccurrence.schema.demcleint || multiOccurrenceComposant.multiOccurrence.schema.eplcleint)
            )
        ) {
            const multiOccurrence = multiOccurrenceComposant.multiOccurrence;

            if (multiOccurrence.dataList) {
                if (!multiOccurrenceComposant.criteresSuggeresVisibles) {
                    vm.rendering = true;
                }

                if (vm.queryParams.employe) {
                    fetchEmploye();
                }

                watchActiveRowChange(multiOccurrence);
            } else {
                multiOccurrence.once('dataListUpdate', () => {
                    if (!multiOccurrenceComposant.criteresSuggeresVisibles) {
                        vm.rendering = true;
                    }

                    if (vm.queryParams.employe) {
                        fetchEmploye();
                    }

                    watchActiveRowChange(multiOccurrence);
                });
            }
        }
    }

    function getFavorisKey(favori: IFavorisMenu) {
        return `${favori.pracleint}-${favori.medcleintref}-${favori.vaesysenttrt}-${favori.mencleint}`;
    }

    function syncFavorisOrder(event: MouseEvent) {
        if (event && event.currentTarget) {
            const target = angular.element(event.currentTarget as HTMLElement);
            $timeout(() => updateFavorisOrder(target));
        }
    }

    function updateFavorisOrder(dropzoneEl: IAugmentedJQuery) {
        if (!vm.favoris || !vm.favoris.length || !dropzoneEl || !dropzoneEl.children().length) {
            return;
        }

        const favorisPersistesBruts = localStorage.getItem(vm.cleFavoris);
        const favorisPersistes = favorisPersistesBruts
            ? JSON.parse(favorisPersistesBruts)
            : [];

        const pracleintCourant = vm.profilsAcces && vm.profilsAcces.length
            ? vm.profilsAcces[0].pracleint
            : null;

        const autresFavoris = favorisPersistes.filter((favori: IFavorisMenu) => favori.pracleint !== pracleintCourant);

        const favorisByKey = vm.favoris.reduce((result, favori) => {
            result[getFavorisKey(favori)] = favori;
            return result;
        }, {} as { [key: string]: any });

        const favorisOrdonnes = dropzoneEl.children().toArray()
            .map((element: HTMLElement) => {
                const favoriKey = element.getAttribute('data-favori-id');
                return favoriKey ? favorisByKey[favoriKey] : undefined;
            })
            .filter((favori) => favori);

        if (favorisOrdonnes.length !== vm.favoris.length) {
            return;
        }

        vm.favoris = favorisOrdonnes;
        const favorisProfilCourant = vm.favoris.map((favori: IFavorisMenu) => ({
            pracleint: favori.pracleint,
            medcleintref: favori.medcleintref,
            vaesysenttrt: favori.vaesysenttrt,
            mencleint: favori.mencleint
        }));

        const favorisSauvegardes = autresFavoris.concat(favorisProfilCourant);

        localStorage.setItem(vm.cleFavoris, JSON.stringify(favorisSauvegardes));
        $rootScope.$emit(vm.cleFavoris, favorisSauvegardes);
    }

    function watchActiveRowChange(multiOccurrence: IMultiOccurrence) {
        if (unregisterActiveRowChange) {
            unregisterActiveRowChange();
            unregisterActiveRowChange = null;
        }
        
        unregisterActiveRowChange = $scope.$watch(() => multiOccurrence.activeRowCleint, () => {
            vm.activeRow = multiOccurrence.getDataActiveRow();

            // Vide immédiatement l'affichage pour éviter de montrer une valeur obsolète
            vm.infosEmploye = undefined;

            const newEmploye = vm.activeRow && (vm.activeRow.demcleint || vm.activeRow.employe_demcleint);

            if (!vm.activeRow || !newEmploye) {
                vm.queryParams.employe = employeParam || null;
                vm.queryParams.emprech = undefined;
                vm.rendering = false;
                return;
            } 
            
            // Si l'id a changé ou si on n'a pas d'infos, on recharge
            if (!vm.queryParams.employe || (vm.queryParams.employe !== vm.activeRow.demcleint && vm.queryParams.employe !== vm.activeRow.employe_demcleint)) {
                vm.rendering = false;
                vm.queryParams.employe = newEmploye
                fetchEmploye()
            }
        });
    }

    function fetchEmploye() {        
        resource.query({
            usrcleint: profil.preferences.usrcleint,
            srccodref: $stateParams.srccod,
            filter: `demcleint{:}${vm.queryParams.employe}`,
            cols: "eplnummat,eplnomprnusu",
            ...parametresSecurite($stateParams, ecranDetails)
        }).$promise.then((rows: any[]) => {
            if (!rows || !rows.length) {
                vm.infosEmploye = '';
                vm.queryParams.emprech = undefined;
                return;
            }
            vm.infosEmploye = `${rows[0].eplnummat} - ${rows[0].eplnomprnusu}`
            // Permet de faire fonctionner RR0149, le paramètre est enlevé pour les autres écrans
            vm.queryParams.emprech = `${rows[0].eplnummat} ${rows[0].eplnomprnusu}`
        });
    }

    function prepareFavoris(favoris: IFavorisMenu[]) {
        return favoris.map(favori => {
            const profil = vm.profilsAcces.find(p => p.pracleint === favori.pracleint)
            if (profil) {
                return findItemInProfil(favori, profil.menus)
            }
        }).filter(favori => favori)
    }

    function findItemInProfil(favori: IFavorisMenu, navigationItems: IMenuNavigationItem[]): any {
        for (const navigationItem of navigationItems) {
            if (navigationItem.medcleintref === favori.medcleintref && navigationItem.mencleint === favori.mencleint && navigationItem.vaesysenttrt === favori.vaesysenttrt) return { ...favori, navigationItem }
            if (navigationItem.items) {
                const foundItem = findItemInProfil(favori, navigationItem.items)
                if (foundItem) return foundItem
            }
        }
    }

}
